import {BrowserRouter, Routes,Route} from 'react-router'
import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import Home from './Home.jsx'
import Newsletter from './Newsletter.jsx'
import Giftcards from './Giftcards.jsx'
import Info from './Info.jsx'
import FreeParking from './FreeParking.jsx'
import ChefBio from './ChefBio.jsx'
import PrivateParties from './PrivateParties.jsx'
import Dinner from './Dinner.jsx'
import Specials from './Specials.jsx'
import Dessert from './Dessert.jsx'
import Press from './Press.jsx'
import Jobs from './Jobs.jsx'
import Manager from './Manager/Manager.jsx'
import DinnerMenu from './Manager/DinnerMenu.jsx'
// import TakeoutMenu from './Manager/TakeoutMenu.jsx'
import DessertMenu from './Manager/DessertMenu.jsx'

import ToGoMenu from './Manager/ToGoMenu.jsx'
import TakeoutMenuFormat from './Manager/TakeoutMenuFormat.jsx'
import TakeoutMenuPrint from './Manager/TakeoutMenuPrint.jsx'
import TakeoutScan from './Manager/TakeoutMenuScan.jsx'

import AnniversaryQR from './AnniversaryQR.jsx'
import AnniversaryScan from './Manager/AnniversaryScan.jsx'
import AnniversaryUpdate from './Manager/AnniversaryUpdate.jsx'
import Anniversary from './Anniversary.jsx'
import AnniversaryFormatPrint from './Manager/AnniversaryFormatPrint.jsx'
import EventsAnniversary from './Manager/EventsAnniversary.jsx'

import ValentinesDay from './Manager/ValentinesDay.jsx'
import ValentinesDayScreenshot from './Manager/ValentinesDayScreenshot.jsx'
import ValentinesDayScan from './Manager/ValentinesDayScan.jsx'

import QRfamilyWeekend from './QR-family-weekend.jsx'
import FamilyWeekend from './FamilyWeekend.jsx'
import ParentsWeekend from './Manager/ParentsWeekend.jsx'
import ParentsWeekendFormatPrint from './Manager/ParentsWeekendFormatPrint.jsx'
import ParentsWeekendUpdate from './Manager/ParentsWeekendUpdate.jsx'
import ParentsWeekendScan from './Manager/ParentsWeekendScan.jsx'
import ParentsWeekendScreenshot from './Manager/ParentsWeekendScreenshot.jsx'

import CommencementDashboard from './Manager/CommencementDashboard.jsx'
import CommencementScreenshot from './Manager/CommencementScreenshot.jsx'
import CommencementUpdate from './Manager/CommencementUpdate.jsx'
import CommencementFormat from './Manager/CommencementFormat.jsx'
import CommencementPrint from './Manager/CommencementPrint.jsx'
import CommencementMenu from './CommencementMenu.jsx'
import Commencement from './Commencement.jsx'

import MothersDayDashboard from './Manager/MothersDayDashboard.jsx'
import MothersDayScreenshot from './Manager/MothersDayScreenshot.jsx'

import NYE from './Manager/NYE.jsx'
import NYEscan from './Manager/NYEscan.jsx'
import NYEscreenshot from './Manager/NYEscreenshot.jsx'

import DinnerMenuUpdate from './Manager/DinnerMenuUpdate.jsx'
import DinnerMenuFormat from './Manager/DinnerMenuFormat.jsx'
import DinnerMenuPrint from './Manager/DinnerMenuPrint.jsx'

import SpecialsMenu from './Manager/SpecialsMenu.jsx'
import SpecialsMenuUpdate from './Manager/SpecialsMenuUpdate.jsx'
import SpecialsMenuFormat from './Manager/SpecialsMenuFormat.jsx'
import SpecialsMenuPrint from './Manager/SpecialsMenuPrint.jsx'

import DessertMenuUpdate from './Manager/DessertMenuUpdate.jsx'
import DessertMenuFormat from './Manager/DessertMenuFormat.jsx'
import DessertMenuPrint from './Manager/DessertMenuPrint.jsx'
import DessertsUpdate from './Manager/DessertsUpdate.jsx'
import DessertDrinksUpdate from './Manager/DessertDrinksUpdate.jsx'
import CoffeeUpdate from './Manager/CoffeeUpdate.jsx'
import TeaUpdate from './Manager/TeaUpdate.jsx'

import WineRed from './Manager/WineRed.jsx'
import WineWhite from './Manager/WineWhite.jsx'
import WineRosé from './Manager/WineRosé.jsx'
import WineSparkling from './Manager/WineSparkling.jsx'
import WineBTB from './Manager/WineBTB.jsx'
import WineListUpdate from './Manager/WineListUpdate.jsx'
import WineListFormat from './Manager/WineListFormat.jsx'
import WineListFormat2 from './Manager/WineListFormat.jsx'
import WineListPrint from './Manager/WineListPrint.jsx'
import WineListPrint2 from './Manager/WineListPrint.jsx'
import WineBTG from './Manager/WineBTG.jsx'
import Beer from './Manager/Beer.jsx'
import NonAlcoholic from './Manager/NonAlcoholic.jsx'
import Sherries from './Manager/Sherries.jsx'
import Sangria from './Manager/Sangria.jsx'
import Spirits from './Manager/Spirits.jsx'
import CraftDrinks from './Manager/CraftDrinks.jsx'

import WineList from './Manager/WineList.jsx'
import Events from './Manager/Events.jsx'
import RestaurantWeeks from './Manager/RestaurantWeeks.jsx'
import RestaurantWeeksSpring from './Manager/RestaurantWeeksSpring.jsx'
import RestaurantWeeksScan from './Manager/RestaurantWeeksScan.jsx'
import RestaurantWeeksScreenshot from './Manager/RestaurantWeeksScreenshot.jsx'
import RestaurantWeeksSpringScreenshot from './Manager/RestaurantWeeksSpringScreenshot.jsx'
import RestaurantWeeksSpringScan from './Manager/RestaurantWeeksSpringScan.jsx'
import PrinterConfig from './Manager/PrinterConfig.jsx'

import QRrestaurantWeekFallDessert from './QRrestaurantWeekFallDessert.jsx'
import QRrestaurantWeekFall from './QRrestaurantWeekFall.jsx'
import RestaurantWeeksFall from './RestaurantWeeksFall.jsx'
import RestaurantWeeksFallUpdate from './Manager/RestaurantWeeksFallUpdate.jsx'
import RestaurantWeeksFallFormatPrint from './Manager/RestaurantWeeksFallFormatPrint.jsx'

import Login from './Manager/Login.jsx'
import Register from './Manager/Register.jsx'
import Dashboard from './Manager/Dashboard.jsx'
import Dashboard2 from './Manager/Dashboard2.jsx'
import GuestUser from './Manager/GuestUser.jsx'
import UsersControlPanel from './Manager/UsersControlPanel.jsx'
import ManageUsers from './Manager/ManageUsers.jsx'
import ProtectedRoute from './Manager/ProtectedRoute.jsx'

import Menu from './Menu.jsx'
import QRspecials from './QR-specials.jsx'
import QRdessert from './QR-dessert.jsx'

import MothersDayMenu from './MothersDayMenu.jsx'
import MothersDay from './MothersDay.jsx'
import MothersDayUpdate from './Manager/MothersDayUpdate.jsx'
import MothersDayFormat from './Manager/MothersDayFormat.jsx'
import MothersDayPrint from './Manager/MothersDayPrint.jsx'

import PageNotFound from './PageNotFound.jsx'

ReactDOM.createRoot(document.getElementById('root')).render(
  // <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='info' element={<Info />} />
        <Route path='free-parking' element={<FreeParking />} />
        <Route path='chef-bio' element={<ChefBio />} />
        <Route path='private-parties' element={<PrivateParties />} />
        <Route path='dinner' element={<Dinner />} />
        <Route path='dinner' element={<Dinner />} />
        <Route path='specials' element={<Specials />} />
        <Route path='dessert' element={<Dessert />} />
        <Route path='newsletter' element={<Newsletter />} />
        <Route path='giftcards' element={<Giftcards />} />
        <Route path='press' element={<Press />} />
        <Route path='jobs' element={<Jobs />} />
        
        {/* QR CODE MENUS */}
        <Route path='menu' element={<Menu />} />
        <Route path='menus' element={<Menu />} />
        <Route path='QR-specials' element={<QRspecials />} />
        <Route path='QR-dessert' element={<QRdessert />} />



        <Route path='manager' element={<Manager />} />
        <Route path='dinner-menu' element={<DinnerMenu />} />
        {/* <Route path='takeout-menu' element={<TakeoutMenu />} /> */}
        <Route path='takeout' element={<ToGoMenu />} />
        <Route path='wine-list' element={<WineList />} />
        <Route path='dessert-menu' element={<DessertMenu />} />
        <Route path='specials-menu' element={<SpecialsMenu />} />
        <Route path='/manager/events' element={<Events />} />
        <Route path='printer-config' element={<PrinterConfig />} />
        
        <Route path='wine-red' element={<WineRed />} />
        <Route path='wine-white' element={<WineWhite />} />
        <Route path='wine-rosé' element={<WineRosé />} />
        <Route path='wine-sparkling' element={<WineSparkling />} />
        <Route path='wine-btg' element={<WineBTG />} />
        <Route path='wine-btb' element={<WineBTB />} />
        <Route path='wine-list-update' element={<WineListUpdate />} />
        <Route path='wine-list-format' element={<WineListFormat />} />
        <Route path='wine-list-format2' element={<WineListFormat2 />} />
        <Route path='wine-list-print' element={<WineListPrint />} />
        <Route path='wine-list-print2' element={<WineListPrint2 />} />
        <Route path='non-alcoholic' element={<NonAlcoholic />} />
        <Route path='sherries' element={<Sherries />} />
        <Route path='beer' element={<Beer />} />
        <Route path='sangria' element={<Sangria />} />
        <Route path='spirits' element={<Spirits />} />
        <Route path='craft-drinks' element={<CraftDrinks />} />
        
        <Route path='specials-menu-update' element={<SpecialsMenuUpdate />} />
        <Route path='specials-menu-format' element={<SpecialsMenuFormat />} />
        <Route path='specials-menu-print' element={<SpecialsMenuPrint />} />

        <Route path='dinner-menu-update' element={<DinnerMenuUpdate />} />
        <Route path='dinner-menu-format' element={<DinnerMenuFormat />} />
        <Route path='dinner-menu-print' element={<DinnerMenuPrint />} />

        <Route path='dessert-menu-update' element={<DessertMenuUpdate />} />
        <Route path='desserts-update' element={<DessertsUpdate />} />
        <Route path='dessert-drinks-update' element={<DessertDrinksUpdate />} />
        <Route path='coffee-update' element={<CoffeeUpdate />} />
        <Route path='tea-update' element={<TeaUpdate />} />
        <Route path='dessert-menu-format' element={<DessertMenuFormat />} />
        <Route path='dessert-menu-print' element={<DessertMenuPrint />} />

        <Route path='login' element={<Login />} />
        <Route path='register' element={<Register />} />
        <Route path='protected-route' element={<ProtectedRoute />} />
        <Route path='manager/dashboard' element={<Dashboard />} />
        <Route path='manager/dashboard2' element={<Dashboard2 />} />
        <Route path='guest-user' element={<GuestUser />} />
        <Route path='manager/users-control-panel' element={<UsersControlPanel />} />
        <Route path='manage-users' element={<ManageUsers />} />



        <Route path='restaurant-weeks-spring' element={<RestaurantWeeksSpring />} />
        <Route path='restaurant-weeks-spring-screenshot' element={<RestaurantWeeksSpringScreenshot />} />
        <Route path='restaurant-weeks-spring-scan' element={<RestaurantWeeksSpringScan />} />

        <Route path='qr-restaurant-week-fall-dessert' element={<QRrestaurantWeekFallDessert />} />
        <Route path='qr-restaurant-week-fall' element={<QRrestaurantWeekFall />} />
        <Route path='restaurant-weeks-fall' element={<RestaurantWeeksFall />} />
        <Route path='restaurant-weeks-fall-format-print' element={<RestaurantWeeksFallFormatPrint />} />
        <Route path='restaurant-weeks-fall-update' element={<RestaurantWeeksFallUpdate />} />
        <Route path='restaurant-weeks' element={<RestaurantWeeks />} />
        <Route path='restaurant-weeks-screenshot' element={<RestaurantWeeksScreenshot />} />
        <Route path='restaurant-weeks-scan' element={<RestaurantWeeksScan />} />
        
        <Route path='takeout-scan' element={<TakeoutScan />} />
        <Route path='takeout-menu-format' element={<TakeoutMenuFormat />} />
        <Route path='takeout-menu-print' element={<TakeoutMenuPrint />} />

        <Route path='anniversary-qr' element={<AnniversaryQR />} />
        <Route path='anniversary-scan' element={<AnniversaryScan />} />
        <Route path='anniversary-update' element={<AnniversaryUpdate />} />
        <Route path='anniversary' element={<Anniversary />} />
        <Route path='anniversary-format-print' element={<AnniversaryFormatPrint />} />
        <Route path='events-anniversary' element={<EventsAnniversary />} />
        
        <Route path='/manager/commencement-update' element={<CommencementUpdate />} />
        <Route path='/manager/commencement-format' element={<CommencementFormat />} />
        <Route path='/manager/commencement-print' element={<CommencementPrint />} />
        <Route path='/manager/commencement-dashboard' element={<CommencementDashboard />} />
        <Route path='commencement-screenshot' element={<CommencementScreenshot />} />
        <Route path='commencement-menu' element={<CommencementMenu />} />
        <Route path='commencement' element={<Commencement />} />
        
        <Route path='mothers-day-menu' element={<MothersDayMenu />} />
        <Route path='/manager/mothers-day' element={<MothersDayDashboard />} />
        <Route path='/manager/mothers-day-update' element={<MothersDayUpdate />} />
        <Route path='mothers-day-screenshot' element={<MothersDayScreenshot />} />
        <Route path='/manager/mothers-day-update' element={<MothersDayUpdate />} />
        <Route path='/manager/mothers-day-format' element={<MothersDayFormat />} />
        <Route path='/manager/mothers-day-print' element={<MothersDayPrint />} />
        <Route path='/mothers-day' element={<MothersDay />} />
        
        
        <Route path='valentines-day' element={<ValentinesDay />} />
        <Route path='valentines-day-screenshot' element={<ValentinesDayScreenshot />} />
        <Route path='valentines-day-scan' element={<ValentinesDayScan />} />

        <Route path='qr-family-weekend' element={<QRfamilyWeekend />} />
        <Route path='yale-family-weekend' element={<FamilyWeekend />} />
        <Route path='parents-weekend' element={<ParentsWeekend />} />
        <Route path='parents-weekend-format-print' element={<ParentsWeekendFormatPrint />} />
        <Route path='parents-weekend-update' element={<ParentsWeekendUpdate />} />
        <Route path='parents-weekend-scan' element={<ParentsWeekendScan />} />
        <Route path='parents-weekend-screenshot' element={<ParentsWeekendScreenshot />} />

        <Route path='nye' element={<NYE />} />
        <Route path='nye-scan' element={<NYEscan />} />
        <Route path='nye-screenshot' element={<NYEscreenshot />} />
        
        <Route path='page-not-found' element={<PageNotFound />} />
        <Route path='*' element={<PageNotFound />} />


      </Routes>
    </BrowserRouter>
  // </StrictMode>
)
